import { render, staticRenderFns } from "./AccountShow.vue?vue&type=template&id=01ef3464&"
import script from "./AccountShow.vue?vue&type=script&lang=js&"
export * from "./AccountShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports